import { AOString } from './ao-string';

// @dynamic

export class AOValidations {

  static isEmail(value) {
    return /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(value);
  }

  static isFloat(value): any {
    return /^-?[\d]+(\.?\d+)?$/.test(value);
  }

  static isFloat_S(value): any {
    return /^-[\d]+(\.?\d+)?$/.test(value);
  }

  static isFloat_U(value): any {
    return /^[\d]+(\.?\d+)?$/.test(value);
  }

  static isInt(value): any {
    return /^-?[\d]+$/.test(value);
  }

  static isInt_S(value): any {
    return /^-[\d]+$/.test(value);
  }

  static isInt_U(value): any {
    return /^[\d]+$/.test(value);
  }

  //
  // (99) 9999-9999
  // (99) 9-9999-9999
  //
  static isPhone(value): any {
    if (/^\([1-9]{1}[0-9]{1}\) ([0-9]{1}-|)[0-9]{4}-[0-9]{4}$/.test(value) == false) return false;

    value = AOString.onlyNumbers(value);

    if (['10', '20', '30', '40', '50', '60', '70', '80', '90'].indexOf(value.substr(0, 2)) >= 0) return false;

    return true;
  }

  static isPhoneINTER(value): any {
    return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value);
  }

  //
  // 99.999-999
  //
  static isZipCode(value): any {
    return /^[0-9]{2}\.[0-9]{3}-[0-9]{3}$/.test(value);
  }

  static isZipCodeINTER(value): any {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);
  }

  //
  // 999.999.999-99
  //
  static isCpf(value): any {
    if (/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/.test(value) == false) return false;

    const invalided = [
      '00000000000', '11111111111', '22222222222', '33333333333', '44444444444',
      '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'
    ];

    value = AOString.onlyNumbers(value);
    if (!value || value.length != 11 || invalided.indexOf(value) >= 0) return false;

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) soma = soma + parseInt(value.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(value.substring(9, 10))) return false;

    soma = 0;

    for (let i = 1; i <= 10; i++) soma = soma + parseInt(value.substring(i - 1, i)) * (12 - i);

    resto = (soma * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(value.substring(10, 11))) return false;

    return true;
  }

  //
  // 99.999.999/9999-99
  //
  static isCnpj(value): any {
    if (/^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}$/.test(value) == false) return false;

    const invalided = [
      '00000000000000', '11111111111111', '22222222222222', '33333333333333', '44444444444444',
      '55555555555555', '66666666666666', '77777777777777', '88888888888888', '99999999999999'
    ];

    value = AOString.onlyNumbers(value);
    if (!value || value.length != 14 || invalided.indexOf(value) >= 0) return false;

    let soma = 0;
    let tamanho = value.length - 2;
    let numeros = value.substring(0, tamanho);
    let digitos = value.substring(tamanho);
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(0)) return false;

    soma = 0;
    tamanho = tamanho + 1;
    numeros = value.substring(0, tamanho);
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(1)) return false;

    return true;
  }

  static isCpfCnpj(value): any {
    return AOValidations.isCpf(value) || AOValidations.isCnpj(value);
  }

  static isUrl(value): any {
    return /^(http?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
      .test(value);
  }

}
